const getters = {

  productHints: () => {
    return {
      product: {icon: 'mdi-tshirt-crew', name: 'Merch'},
      subscription: {icon: 'mdi-repeat', name: 'Subscription'},
      donation: {icon: 'mdi-thermometer', name: 'Donation'}
    }
  },

  products: state => {
    let products = state.products[state.shopID] || {};
    return Object.keys(products).reduce((a,c)=>{
      a.push({...products[c], ...{shopID: state.shopID}});
      return a;
    },[]);
  },
  
  shop: state => {
    return state.shops[state.shopID] || {};
  },

  shopID: state => {
    return state.shopID;
  },

  content: state => name => {
    return (state.content || {})[name]
  },

  youTube: (state, getters) => {
    let shop = getters['shop'] || {}
    return shop.youtube
  },

  shopCart: state => shopID =>{
    return state.shopCarts[shopID] || {}
  },
  
  cartItemCount: (state, getters) => shopID => {
    return Object.keys(getters.cartItems(shopID)||{}).length
  },

  cartTotal: (state, getters) => shopID => {
    const items = getters.cartItems(shopID)
    const total = (items.reduce((a, i)=>{
      a = a + ((i.amount || 0) * (i.vote.qty || 0))
      return a
    }, 0))
    return total;
  },

  cartItems: (state, getters) => shopID =>{
    return getters.rawItems(shopID).filter(r=>{return !r.saved})
  },

  savedItems: (state, getters) => shopID => {
    return getters.rawItems(shopID).filter(r=>{return r.saved})
  },
  
  rawItems: (state, getters) => shopID => {
    let cart = getters.shopCart(shopID)
    return Object.keys(cart).map( (k) => {
      let r = cart[k]
      let vote = r.vote || {}
      let price = vote.price || {}
      let item = {
        _id: r.item._id,
        name: r.item.name,
        qty: vote.qty || 1,
        amount: r.item && r.item.properties && r.item.properties.price || price.amount || 0,
        idx: k,
        currency: r.item.currency || price.currency,
        currency_icon: r.item.currency_icon,
        frequency: r.frequency,
        saved: !!r.saved,
        vote: vote
      }
      return item 
    }) || []
  },

  itemFrequencies: (state) => {
    state.shops
  },

  shippingAddress: state => {
    let {checks, ...addOnly} = state.shippingAddress
    checks.hacked = true
    return addOnly
  },

  stripeBillingDetails: state => {
    return {
      "email": state.shippingAddress.email,
      "name": state.shippingAddress.name,
    }
  },

  stripeCanShip: state => {
    let checks = state.shippingAddress.checks || {}
    return !!checks.email && !! checks.address
  },

  snackbar: state => {
    return state.snackbar
  },
};

export default getters;